module.exports = __webpack_public_path__ + "img/filters-flat.6627a19.jpg";